import {
  normalizeEvmAddress,
  normalizeSvmAddress,
  SOLANA_CHAIN_ID,
} from "@repo/caip";

/** Validate the URL itself; a ticker must never select a different contract. */
export function resolveExactAssetRouteParams(input: {
  chainId: string;
  tokenAddress: string;
}): { chainId: string; tokenAddress: string } | null {
  if (!/^[1-9][0-9]*$/u.test(input.chainId)) return null;
  const chainId = Number(input.chainId);
  if (!Number.isSafeInteger(chainId)) return null;
  const tokenAddress =
    chainId === SOLANA_CHAIN_ID
      ? normalizeSvmAddress(input.tokenAddress)
      : normalizeEvmAddress(input.tokenAddress);
  return tokenAddress ? { chainId: String(chainId), tokenAddress } : null;
}
